"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeRZRQ = void 0;
var react_1 = __importStar(require("react"));
var title_1 = require("../../title");
require("./index.less");
var tab2_1 = require("../../tab2");
var layout_1 = require("../../layout");
var swr_1 = __importDefault(require("swr"));
var web_1 = require("../../../../../modules/datacenter/web");
var text_1 = require("../../../../../modules/text");
/**
 * 首页融资融券
 * @returns
 */
function HomeRZRQ() {
    return (react_1.default.createElement("div", { className: "homerzrq" },
        react_1.default.createElement(title_1.Title1, null,
            react_1.default.createElement(title_1.Title1.Main, null, "\u725B\u718A\u98CE\u5411\u6807")),
        react_1.default.createElement(tab2_1.Tab2, { mt: 10, boxdata: [
                {
                    tab_html: react_1.default.createElement("a", { href: "https://data.eastmoney.com/rzrq/" }, "\u4E24\u5E02\u878D\u8D44\u4F59\u989D"),
                    more: react_1.default.createElement("span", null, "\u6CE8\uFF1A\u5DEE\u503C = \u878D\u8D44\u4F59\u989D - \u878D\u5238\u4F59\u989D \u00A0 \u5355\u4F4D:\u5143"),
                    faketab: true
                },
                {
                    tab_html: react_1.default.createElement("a", { href: "https://data.eastmoney.com/cjsj/yzgptjnew.html" }, "\u4E2D\u56FD\u80A1\u7968\u8D26\u6237\u7EDF\u8BA1"),
                    faketab: true
                },
                {
                    tab_html: react_1.default.createElement("a", { href: "https://data.eastmoney.com/dzjy/default.html" }, "\u5927\u5B97\u5E02\u573A\u4EA4\u6613\u7EDF\u8BA1"),
                    faketab: true
                }
            ] }),
        react_1.default.createElement(layout_1.Layout2, { mt: 10 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement("div", { className: "rzchart" },
                    react_1.default.createElement("div", { className: "title" }, "\u4E0A\u6D77"),
                    react_1.default.createElement(RZRQSHChartNew, null))),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement("div", { className: "rzchart" },
                    react_1.default.createElement("div", { className: "title" }, "\u6DF1\u5733"),
                    react_1.default.createElement(RZRQSZChartNew, null)))),
        react_1.default.createElement(RZYE, null)));
}
exports.HomeRZRQ = HomeRZRQ;
/**
 *
 * @returns 融资上海
 */
function RZRQSHChart() {
    var _a = (0, swr_1.default)("indexrzrq_sh", function () { return (0, web_1.RZRQHistoryData)('sh'); }, {
        refreshInterval: 10 * 60 * 1000,
        dedupingInterval: 9.9 * 60 * 1000
    }), data = _a.data, error = _a.error;
    console.log(data);
    (0, react_1.useEffect)(function () {
        if (window.emcharts3 && data) {
            var opt = {
                container: '#sh_margindebt_chart',
                width: 492,
                height: 238,
                padding: {
                    right: 35
                }
            };
            var line = new window.emcharts3.line(opt);
            var xy = dataHanlder(data);
            var drawoptions = {
                subfix: '亿元',
                xaxis: xy.time,
                yaxis: [{
                        title: '沪市融资余额',
                        color: '#f00',
                        point: {
                            show: false,
                            type: "stroke",
                            radius: 4
                        },
                        data: xy.data
                    }],
                pop: {
                    showTitle: true
                }
            };
            line.setData(drawoptions);
            line.draw();
        }
    }, [data]);
    return (react_1.default.createElement("div", { id: "sh_margindebt_chart" }));
}
/**
 * 融资金额-上海-svg
 * @returns
 */
function RZRQSHChartNew() {
    var thischart = (0, react_1.useRef)(null);
    var _a = (0, swr_1.default)("indexrzrq_sh", function () { return (0, web_1.RZRQHistoryData)('sh'); }, {
        refreshInterval: 10 * 60 * 1000,
        dedupingInterval: 9.9 * 60 * 1000
    }), data = _a.data, error = _a.error;
    var draw = function () {
        if (window.svgcharts2023 && data) {
            var xy = dataHanlder(data);
            var opt = {
                container: document.getElementById("sh_margindebt_chart"),
                width: 490,
                height: 238,
                xaxis: {
                    data: xy.time
                },
                yaxis: {
                    pointnum: 6,
                    subfix: '亿元',
                    title: '沪市融资余额',
                    data: xy.data
                },
                padding: {
                    t: 10,
                    b: 20,
                    l: 60,
                    r: 20
                }
            };
            var line = new window.svgcharts2023.Line(opt);
            line.draw();
        }
    };
    // console.log(data)
    (0, react_1.useEffect)(function () {
        if (window.miniquotechart2023 && thischart) {
            draw();
        }
    }, [data]);
    return (react_1.default.createElement("div", { id: "sh_margindebt_chart", ref: thischart }));
}
/**
 * 融资-深圳
 * @returns
 */
function RZRQSZChart() {
    var _a = (0, swr_1.default)("indexrzrq_sz", function () { return (0, web_1.RZRQHistoryData)('sz'); }, {
        refreshInterval: 10 * 60 * 1000,
        dedupingInterval: 9.9 * 60 * 1000
    }), data = _a.data, error = _a.error;
    (0, react_1.useEffect)(function () {
        if (window.emcharts3 && data) {
            var opt = {
                container: '#sz_margindebt_chart',
                width: 492,
                height: 238,
                padding: {
                    right: 35
                }
            };
            var line = new window.emcharts3.line(opt);
            var xy = dataHanlder(data);
            var drawoptions = {
                subfix: '亿元',
                xaxis: xy.time,
                yaxis: [{
                        title: '深市融资余额',
                        color: '#f00',
                        point: {
                            show: false,
                            type: "stroke",
                            radius: 4
                        },
                        data: xy.data
                    }],
                pop: {
                    showTitle: true
                }
            };
            line.setData(drawoptions);
            line.draw();
        }
    }, [data]);
    return (react_1.default.createElement("div", { id: "sz_margindebt_chart" }));
}
/**
 * 融资金额-深圳-svg
 * @returns
 */
function RZRQSZChartNew() {
    var thischart = (0, react_1.useRef)(null);
    var _a = (0, swr_1.default)("indexrzrq_sz", function () { return (0, web_1.RZRQHistoryData)('sz'); }, {
        refreshInterval: 10 * 60 * 1000,
        dedupingInterval: 9.9 * 60 * 1000
    }), data = _a.data, error = _a.error;
    var draw = function () {
        if (window.svgcharts2023 && data) {
            var xy = dataHanlder(data);
            var opt = {
                container: document.getElementById("sz_margindebt_chart"),
                width: 490,
                height: 238,
                xaxis: {
                    data: xy.time
                },
                yaxis: {
                    pointnum: 6,
                    subfix: '亿元',
                    title: '深市融资余额',
                    data: xy.data
                },
                padding: {
                    t: 10,
                    b: 20,
                    l: 60,
                    r: 20
                }
            };
            var line = new window.svgcharts2023.Line(opt);
            line.draw();
        }
    };
    (0, react_1.useEffect)(function () {
        if (window.miniquotechart2023 && thischart) {
            draw();
        }
    }, [data]);
    return (react_1.default.createElement("div", { id: "sz_margindebt_chart", ref: thischart }));
}
/**
 * xy坐标数据格式化
 * @param json
 * @returns
 */
function dataHanlder(json) {
    var time = [], data = [];
    if (json.length > 0) {
        var splitNum = json.length / 4;
        for (var i = json.length - 1; i >= 0; i--) {
            var item = json[i];
            time.push({
                show: (i % splitNum === 0 || i === json.length - 1) && i != 0,
                showline: false,
                name: (item === null || item === void 0 ? void 0 : item.DIM_DATE.length) > 10 ? item.DIM_DATE.substring(0, 10) : ''
            });
            data.push((item.RZYE / Math.pow(10, 8)).toFixed(2));
        }
    }
    return {
        time: time,
        data: data
    };
}
/** 融资余额 */
function RZYE() {
    var _a;
    var _b = (0, swr_1.default)("indexrzrq_rzye", function () { return (0, web_1.RZRQYE)(); }, {
        refreshInterval: 10 * 60 * 1000,
        dedupingInterval: 9.9 * 60 * 1000
    }), data = _b.data, error = _b.error;
    var sh, sz, bj, total;
    if (data) {
        sh = data.find(function (v) { return v.BOARD_CODE == '001'; });
        sz = data.find(function (v) { return v.BOARD_CODE == '002'; });
        bj = data.find(function (v) { return v.BOARD_CODE == '007'; });
        total = data.find(function (v) { return v.BOARD_CODE == '008'; });
    }
    if (data && sh && sz && bj && total) {
        return (react_1.default.createElement("div", { className: "rzye" },
            react_1.default.createElement("table", null,
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, "\u4EA4\u6613\u65E5\u671F"),
                        react_1.default.createElement("th", null, "\u5E02\u573A"),
                        react_1.default.createElement("th", null, "\u672C\u65E5\u878D\u8D44\u4F59\u989D(\u5143)"),
                        react_1.default.createElement("th", null, "\u672C\u65E5\u878D\u8D44\u4E70\u5165\u989D(\u5143)"),
                        react_1.default.createElement("th", null, "\u672C\u65E5\u878D\u5238\u4F59\u91CF\u4F59\u989D(\u5143)"),
                        react_1.default.createElement("th", null, "\u672C\u65E5\u878D\u8D44\u878D\u5238\u989D(\u5143)"))),
                react_1.default.createElement("tbody", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", { rowSpan: 4 }, ((_a = sh.TRADE_DATE) === null || _a === void 0 ? void 0 : _a.length) > 9 ? sh.TRADE_DATE.substring(0, 10) : ''),
                        react_1.default.createElement("td", null, sh.MARKET),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(sh.FIN_BALANCE)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(sh.FIN_BUY_AMT)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(sh.LOAN_BALANCE)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(sh.MARGIN_BALANCE))),
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", null, sz.MARKET),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(sz.FIN_BALANCE)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(sz.FIN_BUY_AMT)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(sz.LOAN_BALANCE)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(sz.MARGIN_BALANCE))),
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", null, bj.MARKET),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(bj.FIN_BALANCE)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(bj.FIN_BUY_AMT)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(bj.LOAN_BALANCE)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(bj.MARGIN_BALANCE))),
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", null, total.MARKET),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(total.FIN_BALANCE)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(total.FIN_BUY_AMT)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(total.LOAN_BALANCE)),
                        react_1.default.createElement("td", null, (0, text_1.numbericFormat)(total.MARGIN_BALANCE)))),
                react_1.default.createElement("tfoot", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", { colSpan: 6, className: "more" },
                            react_1.default.createElement("a", { href: "http://data.eastmoney.com/rzrq/", target: "_blank" }, "\u70B9\u51FB\u67E5\u770B\u66F4\u591A>>")))))));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
